import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { marked } from 'marked';
import matter from 'gray-matter';
import { getTranslation } from '../lib/i18n';

export function Impressum() {
  const { language } = useLanguage();
  const [content, setContent] = useState('');
  const [contact, setContact] = useState<any>(null);

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    const loadContent = async () => {
      try {
        // Load markdown content
        const response = await fetch(`/content/impressum/${language}.md`);
        if (!response.ok) {
          throw new Error('Failed to load impressum content');
        }
        const text = await response.text();

        // Load contact data from translations
        const contactData = await getTranslation(language, 'contact');

        // Replace placeholders with actual content
        const tmgInfo = `${contactData.address.name}  
${contactData.address.street}  
${contactData.address.postalCode} ${contactData.address.city}  
${contactData.address.country}`;

        const contactInfo = `- **${contactData.office.labels.tel}:** ${contactData.office.tel}  
- **${contactData.office.labels.mobile}:** ${contactData.office.mobile}  
- **${contactData.office.labels.fax}:** ${contactData.office.fax}  
- **${contactData.office.labels.email}:** [${contactData.office.email}](mailto:${contactData.office.email})`;

        const processedText = text
          .replace('{{TMG_INFO}}', tmgInfo)
          .replace('{{CONTACT_INFO}}', contactInfo);

        const { content: markdownContent } = matter(processedText);
        const htmlContent = marked(markdownContent);
        
        setContent(htmlContent);
        setContact(contactData);
      } catch (error) {
        console.error('Error loading impressum content:', error);
        setContent('');
      }
    };
    loadContent();
  }, [language]);

  if (!content || !contact) {
    return (
      <div className="min-h-screen bg-white pt-32">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <div className="animate-pulse">
              <div className="h-8 bg-gray-200 rounded w-1/4 mb-8"></div>
              <div className="space-y-4">
                <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                <div className="h-4 bg-gray-200 rounded w-5/6"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white pt-32">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <div 
            className="prose prose-lg max-w-none"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      </div>
    </div>
  );
}